import {
    LayerTemplate,
    LayerTemplateCreate,
    LayerTemplateDetail,
    LayerTemplateList,
    LayerTemplatePropertyUpdate,
    LayerTemplateUpdate
} from '@/types/layerTemplate';
import { apiClient } from './client';

export interface LayerTemplateListParams {
  skip?: number;
  limit?: number;
  search?: string;
  type?: string;
  is_public?: boolean;
  include_public?: boolean;
  include_user_names?: boolean;
}

export const layerTemplatesApi = {
  // Get list of layer templates
  getTemplatesList: async (params?: LayerTemplateListParams): Promise<LayerTemplateList> => {
    const response = await apiClient.get('/layer-templates/list', { params });
    return response;
  },

  // Get layer template by ID
  getTemplate: async (templateId: string): Promise<LayerTemplateDetail> => {
    const response = await apiClient.get(`/layer-templates/${templateId}`);
    return response;
  },

  // Create new layer template
  createTemplate: async (templateData: LayerTemplateCreate): Promise<LayerTemplate> => {
    const response = await apiClient.post('/layer-templates/', templateData);
    return response;
  },

  // Update layer template
  updateTemplate: async (templateId: string, templateData: LayerTemplateUpdate): Promise<LayerTemplate> => {
    const response = await apiClient.put(`/layer-templates/${templateId}`, templateData);
    return response;
  },

  // Delete layer template
  deleteTemplate: async (templateId: string): Promise<void> => {
    await apiClient.delete(`/layer-templates/${templateId}`);
  },
};

// Convenience functions for direct import
export const getLayerTemplates = layerTemplatesApi.getTemplatesList;
export const getLayerTemplate = layerTemplatesApi.getTemplate;
export const createLayerTemplate = layerTemplatesApi.createTemplate;
export const updateLayerTemplate = layerTemplatesApi.updateTemplate;
export const deleteLayerTemplate = layerTemplatesApi.deleteTemplate;

// Copy layer template function
export const copyLayerTemplate = async (templateId: string): Promise<LayerTemplate> => {
  return apiClient.post(`/layer-templates/${templateId}/copy`);
};

// Update layer template properties function
export const updateLayerTemplateProperties = async (
  templateId: string,
  properties: LayerTemplatePropertyUpdate[],
): Promise<LayerTemplateDetail> => {
  return apiClient.put(`/layer-templates/${templateId}/properties`, { properties });
};
